import UserPlanHistory from 'components/UserOrders/List/UserPlanHistory';

const UserPlansHistoryPageList = () => {
	return <UserPlanHistory />;
};

export default UserPlansHistoryPageList;
